import { OrderOperation } from '@interfaces/movements';

export enum MovementOutcomeKind {
  Pending = 'PENDING',
  Fulfilled = 'FULFILLED',
  CompletedAsCash = 'COMPLETED_AS_CASH',
  RejectedByBroker = 'REJECTED_BY_BROKER',
  TransferFailed = 'TRANSFER_FAILED',
}

export type MovementResource = OrderOperation.Deposit | OrderOperation.Withdrawal;

export interface IOutcomeMovement {
  resource: MovementResource;
  status?: string;
}

export interface IOutcomeOrder {
  status?: string;
  failedOrder?: boolean;
  rejectionCode?: string;
  rejectionMessage?: string;
}

export interface IOutcomeMovementDocument {
  status?: string;
  isSell?: boolean;
  failedOrder?: boolean;
  executedShareVariations?: Array<{ amountUSD?: number }>;
}

export interface MovementOutcome {
  kind: MovementOutcomeKind;
  code?: string;
  message?: string;
}
